/* Shared carousel for the Alchemy sections.
   Markup contract:
     [data-alchemy-carousel-root]      wrapper that also holds the arrows
       [data-alchemy-prev]             optional button
       [data-alchemy-next]             optional button
       [data-alchemy-carousel]         scrolling track
         [data-alchemy-slide]          each slide

   Track data attributes: data-autoplay="true|false", data-interval="5000"
*/
(function () {
  if (window.AlchemyCarousel) return;

  class AlchemyCarousel {
    constructor(track) {
      this.track = track;
      this.root = track.closest('[data-alchemy-carousel-root]') || track.parentElement;
      this.prev = this.root.querySelector('[data-alchemy-prev]');
      this.next = this.root.querySelector('[data-alchemy-next]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = track.dataset.autoplay === 'true' && !this.reduced;
      this.interval = parseInt(track.dataset.interval, 10) || 5000;
      this.timer = null;

      if (this.prev) this.prev.addEventListener('click', () => this.step(-1, true));
      if (this.next) this.next.addEventListener('click', () => this.step(1, true));

      this.track.addEventListener('scroll', () => this.syncArrows(), { passive: true });
      this.track.addEventListener('keydown', (e) => this.onKey(e));

      ['pointerenter', 'focusin'].forEach((e) => this.track.addEventListener(e, () => this.stop()));
      ['pointerleave', 'focusout'].forEach((e) => this.track.addEventListener(e, () => this.start()));

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.start();
      });

      this.syncArrows();
      this.start();
    }

    get stepSize() {
      const slide = this.track.querySelector('[data-alchemy-slide]');
      if (!slide) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 16;
      return slide.offsetWidth + gap;
    }

    get maxScroll() {
      return this.track.scrollWidth - this.track.clientWidth;
    }

    step(dir, manual) {
      if (manual) this.stop();
      if (dir > 0 && this.track.scrollLeft >= this.maxScroll - 2) {
        this.track.scrollTo({ left: 0 });
      } else if (dir < 0 && this.track.scrollLeft <= 2) {
        this.track.scrollTo({ left: this.maxScroll });
      } else {
        this.track.scrollTo({ left: this.track.scrollLeft + dir * this.stepSize });
      }
      if (manual) this.start();
    }

    onKey(e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.step(1, true);
      }
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.step(-1, true);
      }
    }

    syncArrows() {
      if (!this.prev || !this.next) return;
      const noOverflow = this.maxScroll <= 2;
      this.prev.disabled = noOverflow;
      this.next.disabled = noOverflow;
    }

    start() {
      if (!this.autoplay || this.timer || document.hidden) return;
      this.timer = setInterval(() => this.step(1, false), this.interval);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    destroy() {
      this.stop();
    }
  }

  window.AlchemyCarousel = AlchemyCarousel;

  function init(root) {
    (root || document).querySelectorAll('[data-alchemy-carousel]').forEach((track) => {
      if (track.dataset.alchemyReady === 'true') return;
      track.dataset.alchemyReady = 'true';
      track.alchemyCarousel = new AlchemyCarousel(track);
    });
  }

  window.initAlchemyCarousels = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('[data-alchemy-carousel]').forEach((track) => {
      if (track.alchemyCarousel) track.alchemyCarousel.destroy();
    });
  });
})();
